import { apiClient } from "@/api/api-client";
import createBaseService from "@/api/base-service.ts";
import type { CaseActivityLog } from "../../types/case-activity-log";

const caseActivityLogService = {
	...createBaseService<CaseActivityLog>("/backoffice/case-activity-log"),
};

export default caseActivityLogService;
